import { Col, Container, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
// import handleViewport from "react-in-viewport";
import styles from './style.module.scss'
import { parseHtml } from "../../../utils/common";

const Enterprices = (props) => {
  const { data } = props;
  const inViewport = true;
  // const { forwardedRef, inViewport, data } = props;
  const [height, setHeight] = useState();

  useEffect(() => {
    const setView = () => {
      if (window?.innerWidth > 1400) {
        setHeight(560);
      } else {
        setHeight(300);
      }
    };
    setView();

    window.addEventListener("resize", setView);
    return () => {
      window.addEventListener("resize", setView);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section
      // ref={forwardedRef}
      className={`${styles['enterprices-section']} bg-one home-padding-new`}
      style={{ minHeight: `${height}px` }}
    >
      {inViewport && (
        <Container className={styles.container}>
          <Row>
            {data?.statistics &&
              data?.statistics.map((val, i) => {
                return (
                  <Col lg={3} sm={6} xs={6} key={i}>
                    <div
                      className={
                        i < 4
                          ? styles['clientbox-content']
                          : `${styles['clientbox-content']} ${styles['line-green']}`

                      }
                    >
                      <h3 className="text-black h2">{val.numbers}</h3>
                      <p className="text-light-black font-medium">{val.title}</p>
                      <span >{parseHtml(val?.description)}</span>
                    </div>
                  </Col>
                );
              })}
          </Row>
        </Container>
      )}
    </section>
  );
};

// const EnterpricesViewportBlock = handleViewport(Enterprices);

export default Enterprices;
